// extracted by mini-css-extract-plugin
var _1 = "TemplateIcon-module__animateUploadProgressBarWidth--xtzmo";
var _2 = "TemplateIcon-module__animatedBackground--_oERj";
var _3 = "TemplateIcon-module__icon--MU3jb";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "icon" }
